import { related, sourceIds } from './build-planner.mdx';

export { sourceIds, related };
export const quickAnswer =
  '按每个能力选择节点记录你的决定。规划器不会伪造 DPS 或伤害数值，只负责整理能力组合并生成可分享链接。Command 为固定解锁说明。';

## 这套配装工具怎么用

在五个分组中各选一个能力，当前配置会同步展示选择与玩法标签。先记录一套自己熟悉的搭配，再改变一个分组，比较战斗思路。未经官方简中 UI 核验的能力名保留英文，中文玩法标签只解释用途。

## 保存、清除与重置

工具使用浏览器本地存储，不要求账号，也不会连接游戏存档。清除移除对应分组；重置清空 URL 中的配装参数与本地保存。浏览器拒绝存储时仍然可以选择和分享。

## 分享与恢复

点击复制生成分享链接。若复制权限被拒绝，下方会显示可手动复制的链接。五个支持的参数为 artist、dancer、deserter、collective、physicist；有效分享参数优先于本地配装，无分享参数时恢复本地记录。无效值不会变成技能选择。

## 工具边界

这是配装记录工具，不计算伤害、DPS 或游戏内 Build Power，也不代表技能已经解锁。Command 固定展示说明，通关后的额外技能不在五组各选一项的模型内。了解成长请看 [Build Power 说明](/guides/build-power)，额外能力请看[第六个技能槽攻略](/trophies/combat-readiness-sixth-ability-slot)。
